import React from 'react';
import Grid from '@mui/material/Grid';
import Content from './Content.js';
import { IllustratedMessageVariant } from './types.js';
const IllustratedMessage = ({ variant = IllustratedMessageVariant.Vertical, illustration, title, titleProps, action, children, }) => {
    return (React.createElement(Grid, { container: true, spacing: 2, alignItems: "center", ...(variant === IllustratedMessageVariant.Vertical ? { direction: 'column' } : {}), "data-testid": "illustrated-message-wrapper" },
        illustration ? (React.createElement(Grid, { item: true, xs: "auto", "data-testid": "illustrated-message-illustration" }, illustration)) : null,
        React.createElement(Content, { variant: variant, title: title, titleProps: titleProps }, children),
        action ? (React.createElement(Grid, { item: true, xs: "auto", "data-testid": "illustrated-message-action" }, action)) : null));
};
export default IllustratedMessage;
